/**
 * 产品管理api 新增的 以前借口太多  分出来一些
 */
import { createAPI } from '../http'
import axios from "axios";
import { API_SVC_HOST } from '../../config/common';
axios.create({
    baseURL: API_SVC_HOST
});
const api = createAPI();

export function getDatabaseTemplateRadarInfo(params) {
	/**
	 * 获取模板的雷达图信息
	 * @param {object} params	
	 */
	return api.get('/api/database_template_search_v3', params)
}
// 通过hscod_id导出excel模板
export function gethscode_management_excel(params) {
	/**
	 *  产品页  导出hscode的模板  用于展示
	 * @param {object} params	
	 */
	return api.download('/api/hscode_management_excel', params, {
		responseType: 'blob',
	},)
}
export function get_database_list_radar_map(id) {
	/**
	 *  产品页  雷达图数据 完全公开产品
	 * @param {string} id	
	 */
	return api.get(`/api/database_list_radar_map/${id}`)
}

export function get_database_radar_map(id) {
	/**
	 *  产品页  雷达图数据  用户产品
	 * @param {string} id	
	 */
	return api.get(`/api/database_radar_map/${id}`)
}

export function database_template_menu_v3_hscoe(role_key) {
	/**
	 *  获取模板下的所有hscode
	 * @param {string} role_key	
	 */
	return api.get(`/api/database_template_menu_v3/hscode/${role_key}`)
}

export function database_product_by_gtin(gtin) {
	/**
	 * 通过gtin获取产品信息
	 * @param {string} GTIN	
	 */
	return api.get(`/api/database_v3_search_by_keyword?keyword=${gtin}`)
}

export function product_data_transport(params){
	/**
	 * 同步公开产品数据->商城
	 * @param catergory 产品分类
	 * @param  data 产品数据
	 */
	return api.post(`/api/data_transport`, params)
}
